import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);
import store from '~/js/store';
import forms from '~/js/axios.config';

const form = new Vue({
  el: '.js-form',
  data: {
    url: '',
    phone: '',
    name: '',
    email: '',
    sessid: '',
    errors: [],
    isSuccess: false,
  },
  errors: [],
  methods: {
    getUrl() {
      const url = forms.filter(form => form.name === this.$el.name);
      this.url = url[0].url;
    },
    formSubmit(e) {
      this.getUrl();
      e.preventDefault();
      let data = new FormData();

      data.append('sf_name', this.name);
      data.append('sf_email', this.email);
      if (this.phone) data.append('sf_email', this.phone);

      if ((typeof window.recaptcha !== 'undefined') &&
        (typeof window.recaptcha.getToken === 'function')) {
        data.append('recaptcha_token',  window.recaptcha.getToken());
      }

      this.axios
        .post(this.url, data)
        .then(response => {
          this.isSuccess = true;
          response.data = data;
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
  },
});
